import { ZieldefinitionForm } from './ZieldefinitionForm';
import SessionBlockContent from './SessionBlockContent';
import { ReflexionForm } from './ReflexionForm';
import { AbschlussForm } from './AbschlussForm';
import { ErstgespraechForm } from './ErstgespraechForm';
import FollowUpForm from './FollowUpForm';

interface BlockContentProps {
  blockId: string;
  caseId: string;
  moduleType: string;
  contentData: any;
  clientEmail: string;
  clientId?: string;
  sessionId?: string | null;
  sessionNumber?: number | null;
  sessionScheduledAt?: string | null;
  sessionStatus?: string | null;
  onSave: (data: any) => Promise<void>;
  onChanged?: () => void;
}

export default function BlockContent({
  blockId, caseId, moduleType, contentData, clientEmail,
  clientId, sessionId, sessionNumber, sessionScheduledAt, sessionStatus,
  onSave, onChanged,
}: BlockContentProps) {
  switch (moduleType) {
    case 'erstgespraech':
    case 'anamnese':
      return <ErstgespraechForm data={contentData} onSave={onSave} blockId={blockId} clientEmail={clientEmail} />;
    case 'zieldefinition':
      return <ZieldefinitionForm data={contentData} onSave={onSave} blockId={blockId} clientEmail={clientEmail} />;
    case 'session':
      return (
        <SessionBlockContent
          blockId={blockId}
          caseId={caseId}
          clientId={clientId || ''}
          sessionId={sessionId || null}
          sessionNumber={sessionNumber || null}
          sessionScheduledAt={sessionScheduledAt || null}
          sessionStatus={sessionStatus || null}
          clientEmail={clientEmail}
          onSave={onSave}
          onChanged={onChanged || (() => {})}
        />
      );
    case 'reflexion':
      return <ReflexionForm data={contentData} onSave={onSave} blockId={blockId} clientEmail={clientEmail} />;
    case 'abschluss':
      return <AbschlussForm data={contentData} onSave={onSave} blockId={blockId} clientEmail={clientEmail} />;
    case 'followup':
      return <FollowUpForm caseId={caseId} blockId={blockId} clientEmail={clientEmail} />;
    default:
      return null;
  }
}
